import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import fondo from '../assets/viajarjpg.jpg';
import '../styles/disenocalculadorasbase.css'; 

export default function CalculadoraSabatico() {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [edad, setEdad] = useState("");
  const [ingreso, setIngreso] = useState("");
  const [tiempo, setTiempo] = useState("");
  const [crecimiento] = useState("9");

  const handleSubmit = () => {
    navigate("/DisplayCalculo", {
      state: { nombre, edad, ingreso, tiempo, crecimiento }
    });
  };

  return (
    <div 
      className="calculadora-container"
      style={{ backgroundImage: `url(${fondo})` }}
    >
      <div className="calculadora-form">
        <h1>Año sabático</h1>

        <div>
          <label>Nombre:</label>
          <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
          />
        </div>

        <div>
          <label>Edad:</label>
          <input
            type="number"
            value={edad}
            onChange={(e) => setEdad(e.target.value)}
          />
        </div>

        <div>
          <label>Ingreso al fondo (mensualmente):</label>
          <input
            type="number"
            value={ingreso}
            onChange={(e) => setIngreso(e.target.value)}
          />
        </div>

        <div>
          <label>Tiempo (en años):</label>
          <select
            value={tiempo}
            onChange={(e) => setTiempo(e.target.value)}
          >
            {[...Array(20)].map((_, i) => (
              <option key={i + 1} value={i + 1}>{i + 1}</option>
            ))}
          </select>
        </div>

        <button onClick={handleSubmit} className="calculadora-btn">Crear Cálculo</button>
        <p
          onClick={() => navigate("/pantallaCIT")}
          className="calculadora-link"
        >
          No hagas esperar a tu año de descanso, Agenda tu cita aquí!
        </p>
      </div>
    </div>
  );
}


